import React from 'react';
import { 
    Box, 
    Flex, 
    Image, 
    Text, 
    Link 
} from '@chakra-ui/react';
import notFoundImg from '../../img/notFound.png';
import { LinkContext } from '../../LinkContext';

const WrongParams: React.FC = () => {
  return (
    <Flex direction={['column', 'row']} align="center" justify="center" mt={10}>
      <Box mr={[0, 10]} mb={[6, 0]} textAlign="center">
        <Text fontSize="xl">
          Так-так-так... Я не узнаю параметры в ссылке.
          <br /> Видимо что-то не так. Попробуйте найти интересующее Вас направление в нашем{' '}
          <LinkContext.Consumer>
            {(APP_LINK) => (
              <Link href={`${APP_LINK}/guide/?level=bach-spec`} color="blue.500" isExternal>
                Гиде по специальностям.
              </Link>
            )}
          </LinkContext.Consumer>
        </Text>
      </Box>
      <Box>
        <Image src={notFoundImg} maxW="250px" />
      </Box>
    </Flex>
  );
};

const WrongOlympId: React.FC = () => {
  return (
    <Flex direction={['column', 'row']} align="center" justify="center" mt={10}>
      <Box mr={[0, 10]} mb={[6, 0]} textAlign="center">
        <Text fontSize="xl">
          Так-так-так... У меня не получается найти это направление.
          <br /> Видимо что-то не так со ссылкой. Попробуйте найти интересующее Вас направление в нашем{' '}
          <LinkContext.Consumer>
            {(APP_LINK) => (
              <Link href={`${APP_LINK}/guide/?level=bach-spec`} color="blue.500" isExternal>
                Гиде по специальностям.
              </Link>
            )}
          </LinkContext.Consumer>
        </Text>
      </Box>
      <Box>
        <Image src={notFoundImg} maxW="250px" />
      </Box>
    </Flex>
  );
};

const ServerError: React.FC = () => {
  return (
    <Flex direction={['column', 'row']} align="center" justify="center" mt={10}>
      <Box mr={[0, 10]} mb={[6, 0]} textAlign="center">
        <Text fontSize="xl">
          Ой! Сервер сказал, что случилась какая-то ошибка.
          <br /> Попробуйте вернуться к этой странице чуть позже&nbsp;:)
        </Text>
      </Box>
      <Box>
        <Image src={notFoundImg} maxW="250px" />
      </Box>
    </Flex>
  );
};

export { WrongParams, WrongOlympId, ServerError };
